import { lazy } from 'react';

// project imports
import MainLayout from 'jsx/layout/MainLayout';
import Loadable from 'jsx/components/utilities/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

// employer routes
const TimeSheet = Loadable(lazy(() => import('jsx/views/timesheet/employer')));
const Expenses = Loadable(lazy(() => import('jsx/views/expenses/entry')));
const Payroll = Loadable(lazy(() => import('jsx/views/payroll/employer')));
const Employees = Loadable(lazy(() => import('jsx/views/employees/employer')));
const CompanySettings = Loadable(lazy(() => import('jsx/views/company-settings')));
const EmployeeDetails = Loadable(lazy(() => import('jsx/views/employees/employer/employee-details')));
const EmployeeExit = Loadable(lazy(() => import('jsx/views/employees/employer/employee-exit')));
const TaxApprovals = Loadable(lazy(() => import('jsx/views/tax-approvals')));
const Dashboard = Loadable(lazy(() => import('jsx/views/dashboard/employer')));
const AccountProfile = Loadable(lazy(() => import('jsx/views/employees/EmployeeProfile')));
const ChangePassword = Loadable(lazy(() => import('jsx/pages/authentication/auth-forms/ChangePassword')));
const EmployeeSavings = Loadable(lazy(() => import('jsx/views/tax-approvals/employee-savings')));
const NotificationSettings = Loadable(lazy(() => import('jsx/layout/MainLayout/Header/NotificationEnable')));
const Support = Loadable(lazy(() => import('jsx/views/support')));
const AuthForgotPassword = Loadable(lazy(() => import('jsx/pages/authentication/authentication/ForgotPassword')));
// ==============================|| MAIN ROUTING ||============================== //

const EmployerRoutes = {
    path: '/employer',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: 'dashboard',
            element: <Dashboard />
        },
        {
            path: 'account/company-settings',
            element: <CompanySettings />
        },
        {
            path: 'timesheet',
            element: <TimeSheet />
        },
        {
            path: 'employees/add-employee',
            element: <EmployeeDetails />
        },
        {
            path: 'employees/edit-employee/:employee_uuid',
            element: <EmployeeDetails />
        },
        {
            path: 'employees/exit-employee/:employee_uuid',
            element: <EmployeeExit />
        },
        {
            path: 'tax-approvals',
            element: <TaxApprovals />
        },
        {
            path: 'tax-approvals/view/:employeeUuid/:fy',
            element: <EmployeeSavings />
        },
        {
            path: 'employees',
            element: <Employees />
        },
        {
            path: 'expenses',
            element: <Expenses />
        },
        {
            path: 'support',
            element: <Support />
        },
        {
            path: 'payroll',
            element: <Payroll />
        },
        {
            path: 'account/profile',
            element: <AccountProfile />
        },
        {
            path: 'change-password',
            element: <ChangePassword />
        },
        {
            path: 'forgot',
            element: <AuthForgotPassword />
        },
        {
            path: 'notification-settings',
            element: <NotificationSettings />
        },
    ]
};

export default EmployerRoutes;